var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vg-view-field"},[_c('div',{staticClass:"vg-view-field-label",style:({width: _vm.labelWidth})},[_c('label',[_vm._v(_vm._s(_vm.label + (_vm.labelSuffix || '')))])]),_c('div',{staticClass:"vg-view-field-value",class:{bold: _vm.boldValue}},[(this.$slots.default)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.value))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }